<template>
  <div id="app" class="signIn">
    <!-- 导航栏-->
    <header class="back-white">
      <div class="flow-header-container topone">
        <div
          class="logo"
          :style="{
            background:
              'url(' +
              this.$store.state.user.generalSetting.webLogo +
              ') center center no-repeat',
          }"
        >
          <router-link to="/" tag="a"></router-link>
        </div>
        <div class="header-two-right">
          <div class="country-container">
            <div class="china active">
              <span class="country-name">中国</span>
              <span class="country-img countryImgActive"></span>
            </div>
          </div>
          <router-link to="/" tag="a" class="router-link-active"
            >首页</router-link
          >
        </div>
      </div>
    </header>
    <div class="mobile_header">
      <img
        :src="this.$store.state.user.generalSetting.webLogo"
        @click="toIndex()"
      />
      <button @click="toLogin()">登录已有账号</button>
    </div>
    <div style="overflow: hidden" class="pc_register">
      <div class="register">
        <div class="registerContent">
          <form action="">
            <div class="registerTitle">
              欢迎注册{{ this.$store.state.user.channelInfo.channelShortName }}
            </div>
            <p class="accountNumber">
              <span>已有账号？</span>
              <span class="accountLogin" @click="toLogin()">登录</span>
            </p>
            <ul class="ulClass">
              <div class="choosePhone">
                <li class="phone">
                  <!--<label for="phone">中国大陆 +86</label>-->
                  <div class="phoneSele">
                    <select>
                      <option value="1">中国大陆 +86</option>
                      <option value="2">中国香港 +87</option>
                      <option value="3">中国澳门 +88</option>
                      <option value="4">中国台湾 +89</option>
                    </select>
                  </div>
                  <input
                    type="text"
                    id="phone"
                    placeholder="手机号"
                    autocomplete="off"
                    v-model="register.loginName"
                    @blur="phoneVerify()"
                  />
                </li>
                <div class="messageBox">
                  <p v-show="phoneStatus == 0" class="suggest">
                    <i>!</i>
                    <span>建议使用常用手机，方便手机登录和找回密码</span>
                  </p>
                  <p v-show="phoneStatus == 1" class="format">
                    <i class="remindIcon">!</i>
                    <span>请输入合法的手机号</span>
                  </p>
                  <p v-show="phoneStatus == 2" class="format">
                    <i class="remindIcon">!</i>
                    <span>该账号已注册</span>
                  </p>
                  <p v-show="phoneStatus == 3" class="message">
                    <i class="remindIcon">!</i>
                    <span>手机号已占用 ▪</span>
                    <span class="returnAccount" @click="toForgetPassword()"
                      >找回账号？</span
                    >
                  </p>
                </div>
              </div>
              <li>
                <input
                  type="text"
                  placeholder="用户名称"
                  autocomplete="off"
                  v-model="register.name"
                  @blur="blurUserName"
                />
              </li>
              <div class="messageBox">
                <p class="message" v-show="isUserName">
                  <i class="remindIcon">!</i>
                  <span class="pictureMessage">请输入用户名称</span>
                </p>
              </div>
              <li class="password pictureVerification">
                <input
                  type="text"
                  id="pictureCode"
                  placeholder="图片验证码"
                  autocomplete="off"
                  v-model="register.pictureCode"
                  @blur="pictureCodeVerify()"
                />
                <div>
                  <img class="picture" alt="图形验证码" :src="uuPicCode" />
                  <span class="pictureCodeBtn" @click="getPictureCode()"
                    >换一张</span
                  >
                </div>
              </li>
              <div class="messageBox">
                <p class="message" v-show="pictureCodeStatus == 1">
                  <i class="remindIcon">!</i>
                  <span class="pictureMessage">验证码错误</span>
                </p>
                <p class="message" v-show="pictureCodeStatus == 2">
                  <i class="remindIcon">!</i>
                  <span class="pictureMessage">请输入验证码</span>
                </p>
              </div>
              <li class="password">
                <input
                  type="text"
                  style="position: absolute; width: 0; height: 0"
                />
                <input
                  type="text"
                  ref="password"
                  id="password"
                  placeholder="密码"
                  autocomplete="off"
                  v-model="register.password"
                  @blur="passwordVerify()"
                  style="text-security: disc; -webkit-text-security: disc"
                />
              </li>
              <div class="messageBox">
                <p class="suggest" v-show="passwordStatus == 0">
                  <i>!</i>
                  <span>密码长度6-16位，支持数字、字母</span>
                </p>
                <p class="message" v-show="passwordStatus == 1">
                  <i class="remindIcon">!</i>
                  <span>密码格式有误</span>
                </p>
                <p class="message" v-show="passwordStatus == 2">
                  <i class="remindIcon">!</i>
                  <span>请输入密码</span>
                </p>
              </div>
              <li class="password">
                <input
                  type="text"
                  style="position: absolute; width: 0; height: 0"
                />
                <input
                  type="text"
                  ref="againPassword"
                  id="againPassword"
                  placeholder="确认密码"
                  autocomplete="off"
                  v-model="register.password2"
                  @blur="passwordVerify_Second()"
                  style="text-security: disc; -webkit-text-security: disc"
                />
              </li>
              <div class="messageBox">
                <p class="suggest" v-show="passwordStatus_second == 0">
                  <i>!</i>
                  <span>请再次输入密码</span>
                </p>
                <p class="message" v-show="passwordStatus_second == 1">
                  <i class="remindIcon">!</i>
                  <span>两次输入的密码不一致，请重新输入</span>
                </p>
                <p class="message" v-show="passwordStatus_second == 2">
                  <i class="remindIcon">!</i>
                  <span>请再次输入密码</span>
                </p>
              </div>
              <li class="password verificationCode">
                <input
                  type="text"
                  id="code"
                  placeholder="验证码"
                  autocomplete="off"
                  v-model="register.code"
                  @blur="phoneCodeVerify()"
                />
                <input
                  class="sendCode"
                  v-model="phoneCodeText"
                  @click="sendPhoneCode()"
                  :disabled="phoneCodeText == '发送验证码' ? false : true"
                />
              </li>
              <div class="messageBox">
                <p class="message" v-show="phoneNumCodeStatus == 1">
                  <i class="remindIcon">!</i>
                  <span class="pictureError">验证码错误</span>
                </p>
                <p class="message" v-show="phoneNumCodeStatus == 2">
                  <i class="remindIcon">!</i>
                  <span class="pictureError">发送失败</span>
                </p>
                <p class="message" v-show="phoneNumCodeStatus == 3">
                  <i class="remindIcon">!</i>
                  <span class="pictureError">请输入验证码</span>
                </p>
              </div>

              <div class="agree" v-if="visibleAgreements.length > 0">
                <span
                  class="consent"
                  v-show="checkStatus"
                  @click="checkStatus = !checkStatus"
                ></span>
                <span
                  class="disagree"
                  v-show="!checkStatus"
                  @click="checkStatus = !checkStatus"
                ></span>
                <label>
                  我已阅读并同意
                  <span
                    v-for="(item, index) in visibleAgreements"
                    :key="index"
                    @click="onAgreement(item.field)"
                  >
                    <i>{{ item.name }}</i>
                    <i v-if="index !== visibleAgreements.length - 1">、</i>
                  </span>
                </label>
              </div>
              <Button
                type="text"
                class="btn buttonFill"
                :loading="isLoading"
                @click="registerCommit()"
                >立即注册</Button
              >
            </ul>
          </form>
        </div>
      </div>
    </div>
    <div class="mobile_register">
      <h3>账号注册</h3>
      <div class="infoItem phoneNumItem">
        <div class="phoneSele">
          <select>
            <option value="1">中国大陆 +86</option>
            <option value="2">中国香港 +87</option>
            <option value="3">中国澳门 +88</option>
            <option value="4">中国台湾 +89</option>
          </select>
          <input
            type="text"
            v-model="register.loginName"
            placeholder="手机号"
            @blur="phoneVerify()"
          />
        </div>
        <div class="messageBox">
          <p v-show="phoneStatus == 1" class="format">
            <i class="remindIcon">!</i>
            <span>请输入合法的手机号</span>
          </p>
          <p v-show="phoneStatus == 2" class="format">
            <i class="remindIcon">!</i>
            <span>该账号已注册</span>
          </p>
          <p v-show="phoneStatus == 3" class="message">
            <i class="remindIcon">!</i>
            <span>手机号已占用 ▪</span>
            <span class="returnAccount" @click="toForgetPassword()"
              >找回账号？</span
            >
          </p>
        </div>
      </div>
      <div class="infoItem">
        <input
          type="text"
          id="userName"
          placeholder="用户名称"
          v-model="register.name"
          @blur="blurUserName"
        />
        <div class="messageBox">
          <p class="message" v-show="isUserName">
            <i class="remindIcon">!</i>
            <span class="pictureMessage">请输入用户名称</span>
          </p>
        </div>
      </div>
      <div class="infoItem pictureCodeItem">
        <div style="display: flex; justify-content: space-between; width: 100%">
          <input
            type="text"
            placeholder="图片验证码"
            v-model="register.pictureCode"
            @blur="pictureCodeVerify()"
          />
          <img alt="" :src="uuPicCode" />
          <div class="changeOne" @click="getPictureCode()">换一张</div>
        </div>
        <div class="messageBox">
          <p class="message" v-show="pictureCodeStatus == 1">
            <i class="remindIcon">!</i>
            <span class="pictureMessage">验证码错误</span>
          </p>
          <p class="message" v-show="pictureCodeStatus == 2">
            <i class="remindIcon">!</i>
            <span class="pictureMessage">请输入验证码</span>
          </p>
        </div>
      </div>
      <div class="infoItem passwordItem">
        <input
          type="text"
          placeholder="密码"
          v-model="register.password"
          @blur="passwordVerify()"
        />
        <div class="messageBox">
          <p class="message" v-show="passwordStatus == 1">
            <i class="remindIcon">!</i>
            <span>密码格式有误</span>
          </p>
          <p class="message" v-show="passwordStatus == 2">
            <i class="remindIcon">!</i>
            <span>请输入密码</span>
          </p>
        </div>
      </div>
      <div class="infoItem password2Item">
        <input
          type="text"
          placeholder="确认密码"
          v-model="register.password2"
          @blur="passwordVerify_Second()"
        />
        <div class="messageBox">
          <p class="message" v-show="passwordStatus_second == 1">
            <i class="remindIcon">!</i>
            <span>两次输入的密码不一致，请重新输入</span>
          </p>
          <p class="message" v-show="passwordStatus_second == 2">
            <i class="remindIcon">!</i>
            <span>请再次输入密码</span>
          </p>
        </div>
      </div>
      <div class="infoItem codeItem">
        <div class="codeSele">
          <input
            type="text"
            placeholder="验证码"
            v-model="register.code"
            @blur="phoneCodeVerify()"
          />
          <input
            id="sendCode"
            class="sendCode"
            v-model="phoneCodeText"
            @click="sendPhoneCode()"
            :disabled="phoneCodeText == '发送验证码' ? false : true"
            readonly
          />
        </div>
        <div class="messageBox">
          <p class="message" v-show="phoneNumCodeStatus == 1">
            <i class="remindIcon">!</i>
            <span class="pictureError">验证码错误</span>
          </p>
          <p class="message" v-show="phoneNumCodeStatus == 2">
            <i class="remindIcon">!</i>
            <span class="pictureError">发送失败</span>
          </p>
          <p class="message" v-show="phoneNumCodeStatus == 3">
            <i class="remindIcon">!</i>
            <span class="pictureError">请输入验证码</span>
          </p>
        </div>
      </div>

      <div class="agree" v-if="visibleAgreements.length > 0">
        <span
          class="consent"
          v-show="checkStatus"
          @click="checkStatus = !checkStatus"
        ></span>
        <span
          class="disagree"
          v-show="!checkStatus"
          @click="checkStatus = !checkStatus"
        ></span>
        <label>
          我已阅读并同意
          <span
            v-for="(item, index) in visibleAgreements"
            :key="index"
            @click="toAgreement(item.field)"
          >
            <i>{{ item.name }}</i>
            <i v-if="index !== visibleAgreements.length - 1">、</i>
          </span>
        </label>
      </div>
      <Button
        type="text"
        class="btn buttonFill"
        :loading="isLoading"
        @click="registerCommit()"
        >立即注册</Button
      >
    </div>
    <div class="active_Bg" v-show="active">
      <!--注册协议-->
      <div class="agreement registration" v-show="registration">
        <img
          class="img_bg"
          src="../../assets/img/guzhi/agreement_re.png"
          alt="注册协议"
        />
        <div class="text_content">
          <img
            class="logo_title"
            :src="this.$store.state.user.generalSetting.webLogo"
          />
          <img
            class="close"
            src="../../assets/img/guzhi/close.png"
            alt="关闭icon"
            @click="closeActive()"
          />
          <p>注册协议</p>

          <div class="content agreementContent">
            <p
              v-for="(item, i) in formattedContent('registerContent')"
              :key="i"
            >
              {{ item }}
            </p>
          </div>
        </div>
      </div>
      <!-- 免责声明 -->
      <div class="agreement disclaimer" v-show="disclaimer">
        <img
          class="img_bg"
          src="../../assets/img/guzhi/agreementBg.png"
          alt="免责声明"
        />
        <div class="text_content">
          <img
            class="logo_title"
            :src="this.$store.state.user.generalSetting.webLogo"
          />
          <img
            class="close"
            src="../../assets/img/guzhi/close.png"
            @click="closeActive()"
          />
          <p>免责声明</p>
          <div class="content agreementContent">
            <p
              v-for="(item, i) in formattedContent('disclaimerContent')"
              :key="i"
            >
              {{ item }}
            </p>
          </div>
        </div>
      </div>
      <!-- 隐私政策 -->
      <div class="agreement confidentiality" v-show="confidentiality">
        <img
          class="img_bg"
          src="../../assets/img/guzhi/agreementBg.png"
          alt="免责声明"
        />
        <div class="text_content">
          <img
            class="logo_title"
            :src="this.$store.state.user.generalSetting.webLogo"
          />
          <img
            class="close"
            src="../../assets/img/guzhi/close.png"
            @click="closeActive()"
          />
          <p>隐私政策</p>
          <div class="content agreementContent">
            <p v-for="(item, i) in formattedContent('privacyContent')" :key="i">
              {{ item }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <LoginFooter />
  </div>
</template>
<script>
import LoginFooter from "@/common/footer/loginFooter.vue";
import publicMethod from "@/views/publicMethod";
import qs from "qs";
export default {
  name: "register",
  mixins: [publicMethod],
  components: {
    LoginFooter,
  },
  data() {
    return {
      readonly: true,
      readonlySecond: true,
      isLoading: false,
      year: "",
      register: {
        type: 2, // 手机2,邮箱1
        serviceType: 1, // 寻求服务类型
        phoneNum: "", // 账号
        password: "", // 密码
        password2: "", // 确认密码
        pictureCode: "", // 图片验证码
        phoneCode: "", // 手机验证码
        loginName: "", //电话,
        code: "", // 验证码
        name: "", //用户名称
      },
      btnStatus: 0, // 注册状态
      phoneStatus: 0, // 账号提示类型
      pictureCodeStatus: 0, // 图片验证码提示类型
      passwordStatus: 0, // 密码提示类型
      passwordStatus_second: 0, // 密码提示类型
      uuid: "", // 图片验证码id
      uuPicCode: "", // 图片验证码base64
      phoneCodeText: "发送验证码", // 发送验证码按钮text
      phoneNumCodeStatus: 0,
      clauseSure: 0,
      registration: 0, // 心流协议
      disclaimer: 0, // 免责声明
      confidentiality: 0, // 隐私政策
      active: 0,
      checkStatus: false,
      isUserName: false, //用户名称  true 未填写
      registerContent: "",
      disclaimerContent: "",
      privacyContent: "",
    };
  },
  computed: {
    visibleAgreements() {
      const items = [];
      if (this.registerContent)
        items.push({
          name: "注册协议",
          field: "registration",
        });
      if (this.disclaimerContent)
        items.push({
          name: "免责声明",
          field: "disclaimer",
        });
      if (this.privacyContent)
        items.push({
          name: "隐私政策",
          field: "confidentiality",
        });
      return items;
    },
  },
  mounted() {
    // let this_ = this;
    var nowYear = new Date();
    this.year = nowYear.getFullYear();
    this.getPictureCode();

    this.getTxtFile("注册协议", "registerContent");
    this.getTxtFile("免责声明", "disclaimerContent");
    this.getTxtFile("隐私政策", "privacyContent");
  },
  methods: {
    passClick: function () {
      this.$refs.password.blur();
      this.$refs.password.focus();
    },
    passClickSecond: function () {
      this.$refs.againPassword.blur();
      this.$refs.againPassword.focus();
    },
    toIndex: function () {
      this.$router.push({
        name: "home",
        path: "/",
      });
    },
    // 跳转登录页
    toLogin: function () {
      this.$router.push({
        name: "login",
        path: "/login",
      });
    },
    toForgetPassword: function () {
      this.$router.push({
        name: "forgetPassword",
        path: "/forgetPassword",
      });
    },
    // 心流注册协议
    toRegistration: function () {
      this.$router.push({
        name: "registration",
        path: "/registration",
      });
    },
    // 免责声明
    toDisclaimer: function () {
      this.$router.push({
        name: "disclaimer",
        path: "/disclaimer",
      });
    },
    // 隐私政策
    toConfidentiality: function () {
      this.$router.push({
        name: "confidentiality",
        path: "/confidentiality",
      });
    },
    toAgreement(keyName) {
      if (keyName == "registration") {
        this.toRegistration();
      } else if (keyName == "disclaimer") {
        this.toDisclaimer();
      } else if (keyName == "confidentiality") {
        this.toConfidentiality();
      }
    },
    onAgreement(keyName) {
      this.active = 1;
      this[keyName] = 1;
    },
    async getTxtFile(fileName, keysName) {
      try {
        const response = await fetch("/txt/" + fileName + ".txt");
        const text = await response.text();

        // 判断是否有内容
        if (text && text.trim()) {
          this[keysName] = text;
          console.log("文件有内容:");
        } else {
          this[keysName] = "";
          console.log("文件内容为空");
        }
      } catch (error) {
        console.error("读取文件失败:", error);
      }
    },
    formattedContent(keysName) {
      return this[keysName].split(/\r?\n/).filter((segment) => segment.trim());
    },
    blurUserName: function () {
      if (!this.register.name) this.isUserName = true;
      else this.isUserName = false;
    },
    // 账号(手机号码)验证
    phoneVerify: function () {
      var this_ = this;
      var phoneReg = /^1[3|4|5|6|7|8|9]\d{9}$/; //电话
      if (this_.register.loginName.length != 11) {
        this_.phoneStatus = 1;
      } else if (phoneReg.test(this_.register.loginName)) {
        var params = {};
        params.type = this_.register.type;
        params.loginName = this_.register.loginName;
        this_
          .$post(
            this.domain.dataRealization + "dataCustomer/checkCustomer",
            qs.stringify(params),
          )
          .then((res) => {
            console.log(res);
            var data = res.data;
            if (data) {
              if (data.code == 101) {
                this_.btnStatus = 0;
                this_.phoneStatus = 2;
                return false;
              } else if (data.code == 103) {
                this_.btnStatus = 1;
                this_.phoneStatus = 10;
              }
            }
          });
      }
    },
    // 获取图片验证码
    getPictureCode: function () {
      this.$get(
        this.domain.dataRealization + "dataCustomer/getVerifiCode",
        "",
      ).then((res) => {
        console.log(res);
        if (res.code == 200 && res.content) {
          this.uuid = res.content.uuid;
          this.uuPicCode = res.content.image;
        }
      });
    },
    // 验证图片验证码
    pictureCodeVerify: function () {
      if (this.register.pictureCode) {
        this.$get(
          this.domain.dataRealization + "dataCustomer/checkVerifiCode",
          {
            test: this.register.pictureCode,
            uuid: this.uuid,
          },
        ).then((res) => {
          console.log(res);
          if (res.code != 200) {
            this.pictureCodeStatus = 1;
          } else {
            this.pictureCodeStatus = 10;
          }
        });
      } else {
        this.pictureCodeStatus = 2;
      }
    },
    passFocus() {
      var that = this;
      setTimeout(function () {
        //获取焦点时 同时去除只读，这样可以获取光标，进行输入
        that.readonly = false;
      });
    },
    // 验证密码格式
    passwordVerify: function () {
      if (this.register.password) {
        var passwordReg = /^[A-Za-z0-9@#$%]{6,16}$/; //密码
        if (!passwordReg.test(this.register.password)) {
          this.passwordStatus = 1;
        } else if (passwordReg.test(this.register.password)) {
          this.passwordStatus = 10;
        }
      } else {
        this.passwordStatus = 2;
      }
    },
    // 验证二次密码是否相同
    passwordVerify_Second: function () {
      var that = this;
      setTimeout(function () {
        //获取焦点时 同时去除只读，这样可以获取光标，进行输入
        that.readonlySecond = false;
      });

      if (this.register.password2) {
        if (this.register.password !== this.register.password2) {
          this.passwordStatus_second = 1;
        } else {
          this.passwordStatus_second = 10;
        }
      } else {
        this.passwordStatus_second = 2;
      }
    },
    // 倒计时
    countDown: function (time) {
      var that = this;
      var times;
      if (time == 0) {
        clearTimeout(times);
        that.phoneCodeText = "发送验证码";
      } else {
        that.phoneCodeText = time + "s";
        time--;
        times = setTimeout(function () {
          that.countDown(time);
        }, 1000);
      }
    },
    // 发送验证码
    sendPhoneCode: function () {
      var this_ = this;
      if (
        this_.register.loginName &&
        this_.phoneStatus == 10 &&
        this_.register.pictureCode &&
        this_.pictureCodeStatus == 10
      ) {
        var obj = {
          phoneNum: this_.register.loginName,
          uuid: this_.uuid,
          verifiCode: this_.register.pictureCode,
        };
        this_
          .$post(
            this.domain.dataRealization + "dataCustomer/sendPhoneCode",
            qs.stringify(obj),
          )
          .then((res) => {
            console.log(res);
            var data = res.data;
            if (data.code == 200) {
              this_.countDown(60);
            } else {
              this_.countDown(3);
              this_.phoneNumCodeStatus = 2;
            }
          });
      } else if (!this_.register.loginName || this_.phoneStatus != 0) {
        this_.phoneStatus = 1;
      } else if (!this_.register.pictureCode) {
        this_.pictureCodeStatus = 2;
      } else if (this_.pictureCodeStatus != 0) {
        this_.pictureCodeStatus = 1;
      } else {
        return false;
      }
    },
    // 验证码
    phoneCodeVerify: function () {
      if (this.register.code) {
        this.phoneNumCodeStatus = 10;
      } else {
        this.phoneNumCodeStatus = 3;
      }
    },
    // 关闭窗口
    closeActive: function () {
      var this_ = this;
      this_.active = 0;
      this_.registration = 0;
      this_.disclaimer = 0;
      this_.confidentiality = 0;
    },
    // 注册
    registerCommit: function () {
      var this_ = this;
      console.log("subcommit");
      // 账号检索
      if (this_.phoneStatus != 10) {
        if (!this_.register.loginName || this_.phoneStatus != 2) {
          this_.phoneStatus = 1;
          // this_.$Message.info("请输入合法的手机号");
          return;
        } else {
          // this_.$Message.info("该账号已注册");
          return;
        }
      }

      if (!this_.register.name) {
        this_.isUserName = true;
        return;
      }

      // 图片验证码检索
      if (this_.pictureCodeStatus != 10) {
        if (!this_.register.pictureCode) {
          this_.pictureCodeStatus = 2;
          // this_.$Message.info("请输入验证码");
          return;
        } else {
          this_.pictureCodeStatus = 1;
          // this_.$Message.info("验证码错误");
          return;
        }
      }
      // 密码检索
      if (this_.passwordStatus != 10) {
        if (!this_.register.password) {
          this_.passwordStatus = 2;
          // this_.$Message.info("请输入密码");
          return;
        } else {
          this_.passwordStatus = 1;
          // this_.$Message.info("密码格式有误");
          return;
        }
      }
      // 确认密码检索
      if (this_.passwordStatus_second != 10) {
        if (!this_.register.password2) {
          this_.passwordStatus_second = 2;
          // this_.$Message.info("请再次输入密码");
          return;
        } else {
          this_.passwordStatus_second = 1;
          // this_.$Message.info("两次输入的密码不一致，请重新输入");
          return;
        }
      }
      // 验证码非空判断
      if (!this_.register.code) {
        if (this_.phoneNumCodeStatus == 2) {
          // this_.$Message.info("发送失败，请重新发送");
          return;
        } else {
          this_.phoneNumCodeStatus = 3;
          // this_.$Message.info("请输入验证码");
          return;
        }
      }

      // 协议/声明勾选判断
      if (!this_.checkStatus && this.visibleAgreements.length > 0) {
        let str = "";
        this.visibleAgreements.forEach((item, i) => {
          str +=
            item.name + (i != this.visibleAgreements.length - 1 ? "、" : "");
        });
        this_.$Message.info('请勾选"我已阅读并同意' + str + '"');
        return;
      }
      console.log("注册信息", this_.register);

      this_.isLoading = true;

      this_
        .$post(
          this.domain.dataRealization + "dataCustomer/registered",
          qs.stringify(this_.register),
        )
        .then((res) => {
          console.log(res);
          var data = res.data;
          if (data.code == 200) {
            // this_.$Message.info("注册成功");
            setTimeout(function () {
              this_.isLoading = false;
              this_.$router.push({
                name: "login",
                path: "/login",
              });
            }, 1000);
          } else if (data.code == 104) {
            this_.phoneNumCodeStatus = 1;
            // this_.$Message.info("验证码错误");
          }
        });
    },
  },
};
</script>
<style lang="less">
::-webkit-input-placeholder {
  /* WebKit browsers，webkit内核浏览器 */
  color: #bfbfbf;
}

:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #bfbfbf;
}

::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #bfbfbf;
  text-security: none;
  -webkit-text-security: none;
}

:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #bfbfbf;
}

html,
body,
#app,
#logo > div,
.login-main {
  height: 100%;
}

.signIn {
  width: 100%;
  height: 100%;
  background: url(../../assets/img/login/backgroundImage.jpg) no-repeat center
    center;
  overflow: hidden;
  position: relative;
  background-size: cover;
}

body[hue="3"] .signIn {
  background: url(../../assets/img/login/backgroundImageRed.jpg) no-repeat
    center center;
}

.hide {
  display: none;
}

header.back-white {
  height: 80px;
  border: none;
  position: absolute;
  background: rgba(20, 89, 244, 0.06);
}

header.back-white .header-two-right > a {
  color: #000;
}

.back-f1 {
  background: #f5f7fa;
  color: #fff;
}

header {
  height: 72px;
  width: 100%;
  min-width: 1200px;
  background: #f5f7fa;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

footer {
  height: 399px;
  min-width: 1200px;
  width: 100%;
  background: #f5f7fa;
}

.flow-header-container {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
}

.toptwo > div.logo > a {
  width: 100%;
  height: 100%;
}

.flow-header-container > div.header-two-right {
  float: right;
  width: 130px;
  height: 50px;
  line-height: 50px;
  margin: 15px 0;
}

.header-two-right > span {
  display: inline-block;
  font-size: 14px;
}

.country-container {
  float: left;
  cursor: pointer;
  width: 62px;
  font-size: 0;
}

.country-container > div.active span {
  font-size: 14px;
}

.country-container span {
  display: none;
}

.country-select span {
  display: none;
}

.country-container .active span {
  display: inline-block;
}

.country-select .active span {
  display: inline-block;
}

.header-two-right .country-img,
.header-one-right .country-img {
  height: 15px;
  width: 24px;
  background: url(../../assets/img/login/@2x.svg) no-repeat;
  background-size: 12px 15px;
  margin-left: 8px;
}

.signIn .router-link-active {
  margin-left: 20px;
}

.logogFoot {
  width: 100%;
  height: 80px;
  background: #fff;
  font-size: 14px;
  color: #585858;
  text-align: center;
  line-height: 80px;
  position: absolute;
  bottom: 0;
}

.logogFoot a {
  color: #585858;
  cursor: pointer;
}

/*注册开始*/
.register {
  width: 1200px;
  height: 100%;
  max-height: calc(100% - 170px);
  margin: 0 auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
}

@media screen and (max-height: 800px) {
  .register {
    width: 100%;
    overflow-y: scroll;
  }

  .register .registerContent {
    max-height: 100%;
    position: relative;
    right: calc((100% - 1150px) / 2);
  }

  .registerContent form {
    background: #fff;
    padding-bottom: 10px;
  }
}

.register .bd {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}

.register .registerContent {
  width: 420px;
  background: rgba(255, 255, 255, 1);
  clear: both;
  padding-bottom: 40px;
}

.register .registerTitle {
  width: 160px;
  height: 20px;
  font-size: 20px;
  color: rgba(65, 64, 63, 1);
  padding-top: 49px;
  margin: 0 auto;
  font-weight: bold;
  text-align: center;
}

.register .accountNumber {
  width: 84px;
  height: 14px;
  margin-top: 40px;
  margin-left: 296px;
}

.register .accountNumber span:first-child {
  color: #282828;
  font-size: 12px;
}

.register .accountNumber span:last-child {
  color: var(--mainColor);
  font-size: 12px;
  cursor: pointer;
}

.register .registerMethod {
  width: 100%;
  margin-top: 17px;
  border-bottom: 1px solid #bfbfbf;
}

.register .registerMethod span {
  display: inline-block;
  width: 56px;
  height: 12px;
  padding-bottom: 7px;
  text-align: center;
  cursor: pointer;
}

.register .registerMethod span:first-child {
  margin-left: 128px;
}

.register .registerMethod span.choose {
  border-bottom: 3px solid #4393ff;
}

.register .registerMethod span:last-child {
  margin-left: 89px;
}

.register ul {
  width: 74%;
  margin: 0 auto;
}

.register .phoneSele {
  display: inline-block;
  width: 116px;
}

.register .phoneSele .combo-select {
  border: none;
}

.register .phoneSele .combo-arrow:before {
  right: 5px;
}

.register .phoneSele .combo-arrow {
  width: 30px;
  height: 16px;
  margin-top: 7px;
  border-right: 1px solid #bfbfbf;
}

.register .phoneSele input {
  padding: 0;
  padding-right: 20px;
}

.register .ulClass .phone > input {
  padding-left: 10px;
  width: 167px;
  height: 30px;
}

.register .ulClass li {
  position: relative;
  height: 41px;
  line-height: 50px;
  border-bottom: 1px solid #bfbfbf;
}

.register .ulClass li .combo-dropdown li {
  width: 274px;
  height: 20px;
  line-height: 20px;
}

.register .ulClass .phone label {
  width: 86px;
  height: 15px;
  color: #555454;
  font-size: 16px;
}

.register .ulClass .phone input {
  color: #282828;
}

.register .ulClass li.verificationCode #code {
  width: 220px;
}

.register .ulClass li.verificationCode .sendCode {
  float: right;
  display: inline-block;
  width: 75px;
  cursor: pointer;
  margin-top: 8px;
  line-height: 30px;
  text-align: right;
}

.register .ulClass li.verificationCode .sendCode[disabled="disabled"] {
  color: #282828;
  background: rgba(255, 255, 255, 0);
}

.register .ulClass li.pictureVerification #pictureCode {
  width: 178px;
  box-shadow: inset 0 0 1000px #fff !important;
}

.register .ulClass li.pictureVerification > div {
  float: right;
  display: inline-block;
  width: 121px;
  height: 30px;
  cursor: pointer;
  /* margin-top: 11px;
            line-height: 30px; */
  text-align: right;
}

.register .ulClass li.pictureVerification .picture {
  width: 79px;
  height: 30px;
  vertical-align: middle;
}

.register .ulClass li.pictureVerification .pictureCodeBtn {
  font-size: 12px;
  color: var(--mainColor);
}

.register .ulClass li input {
  font-size: 14px;
  width: 100%;
  box-shadow: inset 0 0 1000px #fff !important;
  height: 30px;
}

.register .format,
.register .message {
  color: #e71f19;
  font-size: 12px;
  margin-top: 7px;
}

.register .format span,
.register .message span {
  height: 12px;
  line-height: 10px;
  margin: 0 0 0 10px;
}

.register .message .returnAccount {
  color: #282828;
}

.register .suggest {
  height: 13px;
  margin-top: 7px;
}

.register .suggest i {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 1px solid #999;
  border-radius: 50%;
  text-align: center;
  line-height: 16px;
  color: #999;
  vertical-align: top;
}

.register .format i.remindIcon,
.register .message i.remindIcon,
.register .suggest i.remindIcon {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 1px solid #e71f19;
  border-radius: 50%;
  text-align: center;
  line-height: 16px;
  vertical-align: top;
  color: #e71f19;
}

.register .suggest span {
  color: #999;
  vertical-align: top;
  margin: 0 0 0 10px;
}

.register .messageBox {
  height: 20px;
}

.register .format.disNone,
.register .message.disNone,
.register .suggest.disNone,
.register .choosePhone.disNone,
.register .chooseEmail.disNone {
  display: none;
}

.register .lookAfter {
  margin-top: 12px;
  font-size: 0;
  width: 300px;
  height: 40px;
}

.register .lookAfter label {
  width: 33px;
  height: 28px;
  font-size: 14px;
  color: #999;
  margin-right: 8px;
  display: inline-block;
  line-height: 28px;
  float: left;
}

.register .lookAfter span:nth-child(2) {
  margin-left: 0;
}

.register .lookAfter span {
  width: 52px;
  height: 28px;
  font-size: 12px;
  margin-left: 12px;
  color: #999;
  border: 1px solid #bfbfbf;
  box-sizing: border-box;
  text-align: center;
  line-height: 28px;
  float: left;
  cursor: pointer;
}

.register .lookAfter span.sele {
  color: #fff;
  border: none;
}

.register .agree {
  padding-top: 10px;
  font-size: 12px;
  display: flex;
  align-items: center;
}

.disagree {
  width: 11.5px;
  height: 12px;
  background: #fff;
  border: 1px solid #bfbfbf;
  cursor: pointer;
  margin-right: 5px;
  border-radius: 2px;
}

.consent {
  width: 11.5px;
  height: 12px;
  background: #fff;
  border: 1px solid #bfbfbf;
  cursor: pointer;
  padding: 1.5px;
  box-sizing: border-box;
  margin-right: 5px;
  border-radius: 2px;
}

.consent::after {
  content: "";
  width: 100%;
  height: 100%;
  background: var(--mainColor);
  cursor: pointer;
  display: block;
}

.register .agree img {
  cursor: pointer;
  width: 10px;
  height: 10px;
  margin: 5px 6px 0 0;
  float: left;
}

.register .agree img.active {
  display: inline-block;
}

.register .agree label {
  color: #bfbfbf;
  line-height: 20px;
  text-align: justify;
}

.register .agree label span {
  color: var(--mainColor);
  /* vertical-align: top; */
  margin-top: -2px;
  cursor: pointer;
}

.register .btn {
  margin-top: 20px;
  width: 300px;
  height: 50px;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
}

/*注册结束*/

.myModa .myAlertBox p {
  padding: 20px;
  line-height: 26px;
  font-size: 14px;
  color: #808080;
  text-align: center;
}

/*协议和声明*/
.active_Bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 22;
}

.agreement {
  position: fixed;
  width: 790px;
  height: 370px;
  margin: -185px 0 0 -395px;
  top: 50%;
  left: 50%;
}

.img_bg {
  position: absolute;
}

.text_content {
  position: relative;
  top: 10px;
}

.logo_title {
  display: block;
  height: 40px;
  margin: 0 auto;
  margin-top: 10px;
}

.close {
  display: block;
  position: absolute;
  width: 12px;
  height: 12px;
  right: 34px;
  top: 15px;
  cursor: pointer;
}

.text_content > p {
  margin-top: 19px;
  text-align: center;
  font-size: 14px;
  color: rgba(40, 40, 40, 1);
  line-height: 14px;
  font-weight: bold;
}

.agreementContent {
  width: 716px;
  height: 230px;
  margin: 0 auto;
  margin-top: 14px;
  background: rgba(241, 241, 241, 1);
  border-radius: 6px;
  padding: 15px 20px;
  overflow-y: scroll;
  font-size: 12px;
  color: rgba(40, 40, 40, 1);
  line-height: 24px;
  text-align: justify;
}

.agreementContent h4 {
  text-indent: 2em;
}

.agreementContent p {
  text-indent: 2em;
  text-align: justify;
}

.myModa .myAlertBox > div.alertBox > p {
  float: left;
  width: 168px;
  font-size: 14px;
  line-height: 40px;
  color: #000;
}

/* 绑定手机号码框 */
.telephoneNumbind {
  width: 406px;
  height: 498px;
  background: #ffffff;
  float: right;
  margin: 200px 0 0 0;
}

.telephoneNumbind h3 {
  /* width: 136px; */
  height: 23px;
  font-size: 22px;
  font-weight: bold;
  color: #41403f;
  line-height: 100%;
  margin: 55px 0 0 0;
  text-align: center;
}

.telephoneNumber,
.pictureCode,
.telephoneNumberTureCode {
  height: 50px;
  margin: 27px 53px 0;
  border-bottom: 1px solid #ccc;
  position: relative;
}

.telephoneNumber input {
  border: none;
  height: 50px;
  /* border-bottom: 1px solid #ccc; */
  width: 100%;
  font-size: 14px;
  line-height: 50px;
}

.telephoneNumber p {
  font-size: 14px;
  color: #f00;
  position: absolute;
  top: 56px;
  left: 0;
}

.pictureCode input {
  border: none;
  height: 50px;
  width: 50%;
  float: left;
  font-size: 14px;
  line-height: 48px;
  vertical-align: middle;
}

.pictureCode img {
  float: left;
  width: 79px;
  height: 30px;
  vertical-align: middle;
  margin: 10px 0 0 0;
}

.pictureCode p {
  float: right;
  color: #1459f4;
  font-size: 14px;
  line-height: 50px;
  cursor: pointer;
}

.pictureCode span {
  color: #f00;
  position: absolute;
  top: 60px;
  left: 0;
  font-size: 14px;
}

.telephoneNumberTureCode input {
  border: none;
  height: 50px;
  /* border-bottom: 1px solid #ccc; */
  width: 60%;
  float: left;
  line-height: 48px;
  font-size: 14px;
}

.telephoneNumberTureCode button {
  border: none;
  height: 33px;
  /* border-bottom: 1px solid #ccc; */
  width: 110px;
  float: right;
  background: #1459f4;
  margin: 8px 0;
  color: #fff;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
}

.telephoneNumberTureCode p {
  color: #f00;
  font-size: 14px;
  position: absolute;
  top: 60px;
  left: 0;
}

.telephoneNumbind > button {
  width: 300px;
  height: 50px;
  background: #1459f4;
  text-align: center;
  color: #fff;
  font-size: 16px;
  font-weight: 400;
  margin: 44px 53px 0;
  cursor: pointer;
}

.telephoneNumbind > p {
  height: 15px;
  font-size: 14px;
  font-weight: bold;
  line-height: 86px;
  text-align: right;
  margin: 0 53px 0 0;
}

.telephoneNumbind p a {
  color: #1459f4;
}

.pc_register {
  height: 100%;
}

.mobile_register {
  display: none;
}

.mobile_header {
  display: none;
}

@media screen and (max-width: 750px) {
  body,
  html {
    // height: auto;
    min-width: 100%;
  }

  #app.signIn {
    margin-top: 0;
    background: #fff;
  }

  header {
    // display: none !important;
  }

  .logogFoot {
    display: none;
  }

  .pc_register,
  .logo {
    display: none;
  }

  .mobile_register {
    display: block;
    padding: 0 20px;
    margin: 30px 0 0 0;
  }

  .mobile_register > h3 {
    font-size: 20px;
    line-height: 60px;
    font-weight: 800;
    text-align: center;
  }

  .mobile_header {
    display: block;
    height: 76px;
    background: #f7f8fa;
    border-bottom: 1px solid #e5e5e5;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
  }

  .mobile_header img {
    width: 180px;
  }

  .mobile_header button {
    background: transparent;
    font-size: 14px;
    color: #1459f4;
  }

  .mobile_register .infoItem {
    width: 100%;
    height: 52px;
    margin: 10px 0 0;
  }

  .mobile_register .infoItem input {
    width: 100%;
    height: 40px;
    border: 1px solid #ddd;
    font-size: 14px;
    line-height: 1;
    text-indent: 14px;
    color: #000;
  }

  .mobile_register .phoneNumItem .phoneSele {
    border: 1px solid #ddd;
  }

  .mobile_register .phoneNumItem input {
    width: 62%;
    margin-left: 3%;
    /* float: left; */
    border: none;
  }

  .mobile_register .pictureCodeItem img {
    height: 40px;
    margin-right: 3%;
    /* float: left; */
    display: inline-block;
  }

  .mobile_register .pictureCodeItem input {
    width: 45%;
    margin-right: 5%;
    float: left;
    display: inline-block;
  }

  .mobile_register .codeItem input {
    width: 55%;
    margin-right: 5%;
    /* float: left; */
    display: inline-block;
  }

  .mobile_register .codeItem input#sendCode {
    width: 40%;
    margin: 0;
    text-indent: 0;
    text-align: center;
  }

  .mobile_register .codeItem button {
    width: 45%;
    /* float: left; */
    display: inline-block;
    border: 1px solid #1459f4;
    color: #1459f4;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background: #fff;
  }

  .mobile_register .pictureCodeItem .changeOne {
    width: 18%;
    float: right;
    margin: 20px 0 0 0;
    font-size: 14px;
    display: inline-block;
    color: #1459f4;
    cursor: pointer;
    text-align: center;
  }

  .mobile_register .phoneNumItem select {
    width: 30%;
    height: 40px;
    float: left;
    margin: 0 0 0 2%;
    background: transparent !important;
  }

  .mobile_register .infoItem .messageBox {
    height: 25px;
    width: 100%;
    margin: 0;
  }

  .mobile_register .infoItem .messageBox span {
    font-size: 14px;
    line-height: 20px;
    color: #999;
    margin: 0 0 0 10px;
  }

  .mobile_register .infoItem .messageBox i {
    width: 15px;
    height: 15px;
    line-height: 15px;
    border: 0.5px solid #999;
    border-radius: 50%;
    color: #999;
    text-align: center;
    font-size: 12px;
    margin: -3px 0 0 0;
  }

  .mobile_register .infoItem .messageBox .format i,
  .mobile_register .infoItem .messageBox .message i {
    color: #e71f19;
    border-color: #e71f19;
  }

  .mobile_register .infoItem .messageBox .format span,
  .mobile_register .infoItem .messageBox .message span {
    color: #e71f19;
  }

  .mobile_register .lookAfter {
    margin: 30px 0 0 0;
  }

  .mobile_register .lookAfter > span {
    width: 70px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    color: #999;
    border: 1px solid #bfbfbf;
    box-sizing: border-box;
    text-align: center;
    /* float: left; */
    margin-left: 5px;
    cursor: pointer;
  }

  .mobile_register .lookAfter > span.sele {
    color: #fff;
    border-color: #fff;
  }

  .mobile_register .lookAfter label {
    width: 40px;
    height: 40px;
    font-size: 16px;
    color: #999;
    margin-right: 8px;
    display: inline-block;
    line-height: 40px;
    float: left;
  }

  .mobile_register .agree {
    margin: 20px 0 0 0;
  }

  .mobile_register .agree > label {
    text-align: justify;
    font-size: 16px;
    line-height: 36px;
  }

  .mobile_register .agree > label span {
    text-align: justify;
    margin-top: -4px;
    color: #1459f4;
    cursor: pointer;
  }

  .mobile_register .agree > img {
    width: 24px;
    height: 24px;
    margin: 4px 16px 0 0;
    float: left;
  }

  .mobile_register .agree > span {
    position: relative;
    top: -2px;
  }

  .mobile_register .btn {
    width: 100%;
    height: 50px;
    text-align: center;
    font-size: 14px;
    margin: 15px 0 0 0;
  }
}
</style>
